export default "__VITE_ASSET__Cbtx4Ac1__"